import { defineComponent as _defineComponent } from 'vue'
import BillingService from './billing-service';
import { useBilling } from '@/components/Billing/Billing.composables';
import IntercomService from '@/utils/IntercomService';

interface Props {
	nudgeTop?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactSalesDropdown',
  props: {
    nudgeTop: { default: 0 }
  },
  setup(__props: any) {



const { user } = useBilling();

const menuItems = [
	{
		text: `Get support`,
		onClick: () => {
			IntercomService.showNewMessage(`I need help with `);
		},
	},
	{
		text: `Request a demo`,
		onClick: () => {
			BillingService.bookACall({ user: user.value });
		},
	},
];

return { __sfc: true,user, menuItems }
}

})